import React from 'react';
import { injectIntl } from 'react-intl';
import logger from '../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      logger.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const title = this.props.title || 'Something went wrong';
    const subtitle = this.props.subtitle || 'An unexpected error occurred. Please try again.';
    const reloadLabel = this.props.reloadLabel || 'Reload Page';
    const goHomeLabel = this.props.goHomeLabel || 'Go to Dashboard';

    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <div className="card shadow-sm border-0" style={{ maxWidth: 480 }}>
          <div className="card-body text-center p-5">
            <h2 className="fw-bold mb-3">{title}</h2>
            <p className="text-muted mb-4">{subtitle}</p>
            <div className="d-flex gap-2 justify-content-center">
              <button className="btn btn-primary" onClick={() => window.location.reload()}>
                {reloadLabel}
              </button>
              <a href="/dashboard" className="btn btn-outline-secondary">
                {goHomeLabel}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ErrorBoundaryWithIntlClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      logger.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { intl } = this.props;
    const title = intl.formatMessage({ id: 'error.title' });
    const subtitle = intl.formatMessage({ id: 'error.subtitle' });
    const reloadLabel = intl.formatMessage({ id: 'error.reload' });
    const goHomeLabel = intl.formatMessage({ id: 'error.goHome' });

    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <div className="card shadow-sm border-0" style={{ maxWidth: 480 }}>
          <div className="card-body text-center p-5">
            <h2 className="fw-bold mb-3">{title}</h2>
            <p className="text-muted mb-4">{subtitle}</p>
            <div className="d-flex gap-2 justify-content-center">
              <button className="btn btn-primary" onClick={() => window.location.reload()}>
                {reloadLabel}
              </button>
              <a href="/dashboard" className="btn btn-outline-secondary">
                {goHomeLabel}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ErrorBoundaryWithIntl = injectIntl(ErrorBoundaryWithIntlClass);

export { ErrorBoundary, ErrorBoundaryWithIntl };
export default ErrorBoundary;
